import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8ZM13.8333 8C13.8333 9.21719 13.4605 10.3473 12.8229 11.2824C12.464 10.1054 11.5884 9.15178 10.461 8.58165C11.0028 7.98889 11.3333 7.19971 11.3333 6.33333C11.3333 4.49238 9.84095 3 8 3C6.15905 3 4.66667 4.49238 4.66667 6.33333C4.66667 7.19971 4.9972 7.98889 5.53904 8.58165C4.41159 9.15178 3.53601 10.1054 3.17712 11.2824C2.53947 10.3473 2.16667 9.21719 2.16667 8C2.16667 4.77834 4.77834 2.16667 8 2.16667C11.2217 2.16667 13.8333 4.77834 13.8333 8ZM4.61998 12.7549C5.57356 13.4339 6.74014 13.8333 8 13.8333C9.25986 13.8333 10.4264 13.4339 11.38 12.7549C11.3498 12.6686 11.3333 12.5758 11.3333 12.4792C11.3333 11.0269 9.94895 9.66667 8 9.66667C6.05105 9.66667 4.66667 11.0269 4.66667 12.4792C4.66667 12.5758 4.65022 12.6686 4.61998 12.7549ZM8 8C8.92047 8 9.66667 7.25381 9.66667 6.33333C9.66667 5.41286 8.92047 4.66667 8 4.66667C7.07953 4.66667 6.33333 5.41286 6.33333 6.33333C6.33333 7.25381 7.07953 8 8 8Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}